/**
 * RT ROTAS DO SISTEMA - PARA SER USADO NA CHAMADA DO COMPONENTE
 * LK link interno da app exemplo: /cadastro/grupo/edit/654654654645-664554-645654
 * EP endpoint: "/grupo/filter?search=textoparametro"
 */

import config from '../../../config/config';
import configUrls from '../../../config/configUrls';
const SITE_NOTICIA_PUBLIC_EP = '/api/site/public/noticia';
const SITE_ANEXO_PUBLIC_EP = '/api/site/public/anexos';
//refatorar as classes que usam o anexo e agora verificar o end point

const configSiteUrls = {
  SITE_MENU_PUBLIC_EP: '/api/site/public/menu',
  SITE_MENU_PAI_EP: '/api/site/admin/menupai',
  SITE_MENU_PAI_CREATE: '/site/admin/cadastro/menupai/create',
  SITE_MENU_PAI_EDIT: '/site/admin/cadastro/menupai/edit/:id',
  SITE_MENU_PAI_LIST: '/site/admin/cadastro/menupai/list',
  SITE_MENU_PAI_EDIT_LK: '/site/admin/cadastro/menupai/edit/',
  SITE_MENU_PAI_FILTER_BY_SEARCH_EP: '/api/site/admin/menupai/filter',

  //SITE_MENU_FILHO_FILTER_BY_SEARCH_EP: "/site/admin/menufilho/filter",

  SITE_MENU_FILHO_EP: '/api/site/admin/menufilho',
  SITE_MENU_FILHO_CREATE: '/site/admin/cadastro/menufilho/create',
  SITE_MENU_FILHO_LIST: '/site/admin/cadastro/menufilho/list',
  SITE_MENU_FILHO_EDIT: '/site/admin/cadastro/menufilho/edit/:id',
  SITE_MENU_FILHO_EDIT_LK: '/site/admin/cadastro/menufilho/edit/',

  SITE_MENU_NETO_EP: '/api/site/admin/menuneto',
  SITE_MENU_NETO_CREATE: '/site/admin/cadastro/menuneto/create',
  SITE_MENU_NETO_LIST: '/site/admin/cadastro/menuneto/list',
  SITE_MENU_NETO_EDIT: '/site/admin/cadastro/menuneto/edit/:id',
  SITE_MENU_NETO_EDIT_LK: '/site/admin/cadastro/menuneto/edit/',

  SITE_NOTICIA_EP: '/api/site/admin/noticia',
  SITE_NOTICIA_PUBLIC_EP,
  //SITE_NOTICIA_URL_CAPA: config.API_URL + SITE_NOTICIA_PUBLIC_EP + '/imagem/capa?filename=',
  SITE_NOTICIA_CREATE: '/site/admin/cadastro/noticia/create',
  SITE_NOTICIA_LIST: '/site/admin/cadastro/noticia/list',
  SITE_NOTICIA_EDIT: '/site/admin/cadastro/noticia/edit/:id',
  SITE_NOTICIA_EDIT_LK: '/site/admin/cadastro/noticia/edit/',

  SITE_NOTICIA_PUBLIC_LIST: '/site/public/noticia/view/',
  SITE_NOTICIA_PUBLIC_VIEW: '/site/public/noticia/view/:id',
  SITE_NOTICIA_PUBLIC_VIEW_LK: '/site/public/noticia/view/',

  SITE_PUBLICACAO_OFICIAL_EP: '/api/site/admin/publicacao-oficial',
  SITE_PUBLICACAO_OFICIAL_PUBLIC_EP: '/api/site/public/publicacao-oficial',

  SITE_PUBLICACAO_OFICIAL_CREATE: '/site/admin/cadastro/publicacao-oficial/create',
  SITE_PUBLICACAO_OFICIAL_EDIT: '/site/admin/cadastro/publicacao-oficial/edit/:id',
  SITE_PUBLICACAO_OFICIAL_LIST: '/site/admin/cadastro/publicacao-oficial/list',
  SITE_PUBLICACAO_OFICIAL_EDIT_LK: '/site/admin/cadastro/publicacao-oficial/edit/',
  SITE_PUBLICACAO_OFICIAL_FILTER_BY_SEARCH_EP: '/api/site/admin/publicacao-oficial/filter',
  SITE_PUBLICACAO_OFICIAL_PUBLIC_LIST: '/site/public/publicacao-oficial/view/',
  SITE_PUBLICACAO_OFICIAL_PUBLIC_LIST_PAR: '/site/public/publicacao-oficial/view/:tipo',

  SITE_LICITACAO_EP: '/api/site/admin/licitacao',
  SITE_LICITACAO_PUBLIC_EP: '/api/site/public/licitacao',
  SITE_LICITACAO_CREATE: '/site/admin/cadastro/licitacao/create',
  SITE_LICITACAO_EDIT: '/site/admin/cadastro/licitacao/edit/:id',
  SITE_LICITACAO_LIST: '/site/admin/cadastro/licitacao/list',
  SITE_LICITACAO_EDIT_LK: '/site/admin/cadastro/licitacao/edit/',
  SITE_LICITACAO_FILTER_BY_SEARCH_EP: '/api/site/admin/licitacao/filter',
  SITE_LICITACAO_PUBLIC_LIST: '/site/public/licitacao/view/',

  SITE_TIPO_PUBLICACAO_OFICIAL_EP: '/api/site/admin/tipo-publicacao-oficial',
  SITE_TIPO_PUBLICACAO_OFICIAL_PUBLIC_EP: '/api/site/public/tipo-publicacao-oficial',
  SITE_TIPO_PUBLICACAO_OFICIAL_CREATE: '/site/admin/cadastro/tipo-publicacao-oficial/create',
  SITE_TIPO_PUBLICACAO_OFICIAL_EDIT: '/site/admin/cadastro/tipo-publicacao-oficial/edit/:id',
  SITE_TIPO_PUBLICACAO_OFICIAL_LIST: '/site/admin/cadastro/tipo-publicacao-oficial/list',
  SITE_TIPO_PUBLICACAO_OFICIAL_EDIT_LK: '/site/admin/cadastro/tipo-publicacao-oficial/edit/',
  SITE_TIPO_PUBLICACAO_OFICIAL_FILTER_BY_SEARCH_EP: '/api/site/admin/tipo-publicacao-oficial/filter',

  SITE_OUVIDORIA_EP: '/api/site/admin/ouvidoria',
  SITE_OUVIDORIA_PUBLIC_EP: '/api/site/public/ouvidoria',
  SITE_OUVIDORIA_PUBLIC_MENU: '/site/public/ouvidoria/menu',
  SITE_OUVIDORIA_PUBLIC_CREATE: '/site/public/ouvidoria/create',
  SITE_OUVIDORIA_PUBLIC_CONSULT: '/site/public/ouvidoria/consult',
  SITE_OUVIDORIA_EDIT_LK: '/site/admin/ouvidoria/edit/',
  SITE_OUVIDORIA_EDIT: '/site/admin/ouvidoria/edit/:id',
  SITE_OUVIDORIA_LIST: '/site/admin/ouvidoria/list',

  SITE_ACESSO_INFORMACAO_EP: '/api/site/admin/acesso-informacao',
  SITE_ACESSO_INFORMACAO_PUBLIC_EP: '/api/site/public/acesso-informacao',
  SITE_ACESSO_INFORMACAO_PUBLIC_MENU: '/site/public/acesso-informacao/menu',
  SITE_ACESSO_INFORMACAO_PUBLIC_CREATE: '/site/public/acesso-informacao/create',
  SITE_ACESSO_INFORMACAO_PUBLIC_CONSULT: '/site/public/acesso-informacao/consult',
  SITE_ACESSO_INFORMACAO_EDIT_LK: '/site/admin/acesso-informacao/edit/',
  SITE_ACESSO_INFORMACAO_EDIT: '/site/admin/acesso-informacao/edit/:id',
  SITE_ACESSO_INFORMACAO_LIST: '/site/admin/acesso-informacao/list',

  SITE_VEREADOR_EP: '/api/site/admin/vereador',
  SITE_VEREADOR_CREATE: '/site/admin/cadastro/vereador/create',
  SITE_VEREADOR_EDIT: '/site/admin/cadastro/vereador/edit/:id',
  SITE_VEREADOR_LIST: '/site/admin/cadastro/vereador/list',
  SITE_VEREADOR_EDIT_LK: '/site/admin/cadastro/vereador/edit/',
  SITE_VEREADOR_FILTER_BY_SEARCH_EP: '/api/site/admin/vereador/filter',

  SITE_CENTRO_APOIO_EP: '/api/site/admin/centro-apoio',
  SITE_CENTRO_APOIO_PUBLIC_EP: '/api/site/public/centro-apoio',
  SITE_CENTRO_APOIO_PUBLIC_MENU: '/site/public/centro-apoio/menu',
  SITE_CENTRO_APOIO_PUBLIC_CREATE: '/site/public/centro-apoio/create',
  SITE_CENTRO_APOIO_PUBLIC_CONSULT: '/site/public/centro-apoio/consult',
  SITE_CENTRO_APOIO_EDIT_LK: '/site/admin/centro-apoio/edit/',
  SITE_CENTRO_APOIO_EDIT: '/site/admin/centro-apoio/edit/:id',
  SITE_CENTRO_APOIO_LIST: '/site/admin/centro-apoio/list',

  SITE_USUARIO_EP: '/api/site/admin/usuario',
  SITE_USUARIO_CREATE: '/site/admin/cadastro/usuario/create',
  SITE_USUARIO_EDIT: '/site/admin/cadastro/usuario/edit/:id',
  SITE_USUARIO_LIST: '/site/admin/cadastro/usuario/list',
  SITE_USUARIO_EDIT_LK: '/site/admin/cadastro/usuario/edit/',
  SITE_USUARIO_FILTER_BY_SEARCH_EP: '/api/site/admin/usuario/filter',

  SITE_ANEXO_URL_IMAGEM: config.API_URL + SITE_ANEXO_PUBLIC_EP + '/imagem?filename=',
  SITE_ANEXO_PUBLIC_EP
};

export default configSiteUrls;
